<template>
  <div v-if="! noContent">
    <div class="row">
      <div class="col-md-12">
        <loading v-if="! showContent"></loading>
        <h2 class="titulo" v-if="showContent && item">{{ title }}</h2>

        <div class="enquete" v-if="! showResult && showContent && item">
          <p v-if="showContent">{{ item.answer }}</p>
          <form v-if="showContent" v-on:submit.prevent="onSubmit">
            <label v-for="option in item.options">
              <input type="radio" v-model="checked" :value="option.value"> {{ option.label }}
            </label>
            <input type="submit" value="Votar" class="btn_enviar">
            <a @click="showResult = true" href="javascript:void(0)">Ver resultado parcial</a>
          </form>
        </div>
        <div class="enquete result" v-if="showResult && showContent && item">
          <p>Resultado parcial</p>
          <div class="percentage">
            <div v-for="option in item.options">
              {{ getOptionLabel(option) }}
              <div class="progress">

                <div
                        class="progress-bar"
                        role="progressbar"
                        :style="'width: '+option.percent+'%'"
                        :aria-valuenow="option.percent"
                        aria-valuemin="0"
                        aria-valuemax="100">
                </div>
              </div>
            </div>
          </div>
          <a @click="showResult = false" href="javascript:void(0)">Voltar</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import {get, post} from '../../helpers/api';
  import Loading from '../common/Loading.vue';

  export default {
    components: {
      Loading
    },
    props: ['bloco'],
    data() {
      return {
        title: 'Enquete',
        showContent: true,
        noContent: false,
        item: {},
        checked: '',
        showResult: false
      }
    },
    created() {
      if (this.bloco.nome) {
        this.title = this.bloco.nome;
      }
      let self = this;

      self.item = this.$store.getters['getSiteContent'].result.data.enquete;

      // self.item = window.siteconfig.result.data.enquete;
      //self.getInfo();
    },
    methods: {
      getInfo() {
        let self = this;
        get('content/' + self.bloco.id).then(function (response) {
          self.showContent = true;
          self.item = response.data.result.data;
          if (self.item.length === 0) {
            self.noContent = true;
          }
        });
      },
      onSubmit() {
        let self = this;
        if (self.checked === '') {
          // swal({
          //     title: "Selecione uma opção.",
          //     icon: "warning",
          // });
          return false;
        }
        post('polling', {pollId: this.checked}).then(function () {
          // swal({
          //   title: "Votação efetuada com sucesso.",
          //   icon: "success",
          // });
          self.checked = '';
          self.getInfo();
          self.showResult = true;
        });
      },
      getPercentage(option) {
        let total = 0;
        this.item.options.forEach(function (obj) {
          total = total + obj.count;
        });

        return ((option.count * 100) / total);
      },
      getOptionLabel(option) {
        let label = option.label;
        if (!option.percent) {
          label = label + ' (0%)';
          return label;
        }
        label = label + ' (' + option.percent + '%)';
        return label;
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/home/Poll.vue